export const endpoint = {
	base: "",
	groupId: "/:groupId",
	enqueteId: `/:enqueteId`,
} as const;
